common.View.create('canvas.blocks.custom.logoSlider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 4444,
            autoplayHoverPause:true,
            responsive: {
                0: {
                    items: 1
                },
                200: {
                    items: 2
                },
                640: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            }
        });

    }
});
